//src/styles/menuStyles.js

const menuStyles = {
  menuPaper: {
    width: '200px',
    boxShadow: 'none',
    border: '1px solid #D3E0EA',
    marginTop: '8px', // Adjust the margin as needed
  },
};

export default menuStyles;
